import React from "react";
import { Route } from "react-router-dom";

// routes
import Landingpage from "../container";

const OptumHomePage = (auth, checkAuthSession) => {
  const routes = (
    <>
      <Route
        path="/optumhome"
        render={props =>
          checkAuthSession(<Landingpage auth={auth} {...props} />)
        }
      />
    </>
  );

  return routes;
};

export default OptumHomePage;
